import React, { useState } from "react";
import authService from "../../services/auth.service";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";

const EducationDetails = ({ qualifications, setQualifications }) => {
  const dispatch = useDispatch();
  const [openForm, setOpenForm] = useState(false);
  const [qualificationErrors, setQualificationErrors] = useState({});
  const [editingIndex, setEditingIndex] = useState(null);

  const [isEditingQualification, setIsEditingQualification] = useState(false);

  const [qualificationFormData, setQualificationFormData] = useState({
    course_name: "",
    course_detailed_name: "",
    roll_no: "",
    course_year: "",
    course_from: "",
    total_marks: "",
    obtained_marks: "",
    obtained_perc: "",
    subjects: "",
    board: "",
  });

  const handleEditQualification = (index) => {
    setIsEditingQualification(true);
    setEditingIndex(index);
    setQualificationFormData({
      ...qualifications[index],
      course_detailed_name: qualifications[index].course_name,
    });
    setOpenForm(true);
  };

  const resetQualificationForm = () => {
    setQualificationFormData({
      course_name: "",
      course_detailed_name: "",
      roll_no: "",
      course_year: "",
      course_from: "",
      total_marks: "",
      obtained_marks: "",
      obtained_perc: "",
      subjects: "",
    });
    setQualificationErrors({});
    setIsEditingQualification(false);
    setEditingIndex(null);
  };

  const handleCloseQualificationForm = () => {
    resetQualificationForm();
    setOpenForm(false);
  };

  const handleQualificationInputChange = (e) => {
    const { name, value } = e.target;
    setQualificationFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "course_name") {
      if (value !== "Other") {
        setQualificationFormData((prev) => ({
          ...prev,
          course_detailed_name: value,
        }));
      } else {
        setQualificationFormData((prev) => ({
          ...prev,
          course_detailed_name: "",
        }));
      }
    }

    if (qualificationErrors[name]) {
      setQualificationErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleAddQualification = async () => {
    const response = await authService.updateAcademic(qualificationFormData);

    if (response.status) {
      await authService.getUser(dispatch);
      Swal.fire({
        title: "Saved",
        icon: "success",
        showConfirmButton: true,
      });
      resetQualificationForm();
      setOpenForm(false);
    } else {
      Swal.fire({
        title: response.message,
        icon: "error",
        showConfirmButton: true,
      });
    }


  };



  return (
    <div>
      <div className="student-profile-page">
        <div className="profile-grid">
          <div className="section-header">
            <div className="section-title" onClick={()=>console.log(qualifications)}>Education Details</div>
            <button
              onClick={() => {
                resetQualificationForm();
                setOpenForm(true);
              }}
              className="edit-button"
            >
              <FaPlus /> Add Education Details
            </button>
          </div>



          <div className="profile-qualification-box">
            {qualifications?.length > 0 ? (
              <div className="qualifications-list">
                {qualifications?.map((qual, index) => (
                  <div className="edu-card" key={index}>
                    <div className="edu-header">
                      <span className="exam-name">
                        {" "}
                        {qual?.course_detailed_name || qual.course_name}
                      </span>

                      <div className="qualification-actions">
                        <div className="year-badge">
                          <p>Passing Year : {qual?.course_year}</p>
                        </div>
                        <button
                          className="edit-qual-btn"
                          onClick={() => handleEditQualification(index)}
                        >
                          <FaEdit />
                        </button>
                      </div>
                    </div>
                    <div className="edu-detail-grid">
                      <div className="edu-detail-item">
                        <span className="edu-label">Roll No.</span>
                        <span className="edu-value">{qual?.roll_no}</span>
                      </div>
                      <div className="edu-detail-item">
                        <span className="edu-label">Board</span>
                        <span className="edu-value">{qual?.board}</span>
                      </div>
                      <div className="edu-detail-item">
                        <span className="edu-label">School</span>
                        <span className="edu-value">{qual?.course_from}</span>
                      </div>
                      <div className="edu-detail-item">
                        <span className="edu-label">Obtained</span>
                        <span className="edu-value">
                          {qual?.obtained_marks}
                        </span>
                      </div>
                      <div className="edu-detail-item">
                        <span className="edu-label">Percentage</span>
                        <span className="edu-value ">
                          {qual?.obtained_perc}%
                        </span>
                      </div>
                      <div className="edu-detail-item">
                        <span className="edu-label">Max. Marks</span>
                        <span className="edu-value">{qual?.total_marks}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-qualifiton-add">
                <div className="empty-state-content">
                  <FaPlus size={15} />
                  <h3>No Education Details Added</h3>
                  <p>
                    Click "Add Education Details" to add your educational
                    qualifications
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {openForm && (
        <div className="modal-qualitciton-form">
          <div
            className="qualification-form-modal-overlay"
            onClick={handleCloseQualificationForm}
          >
            <div
              className="qualification-form-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="main-form-education">
                <div className="qualification-form-modal-header">
                  <h3 onClick={() => console.log(qualificationFormData)}>
                    {isEditingQualification
                      ? "Edit Academic Details"
                      : "Add Academic Details"}
                  </h3>
                  <button
                    className="qualification-form-modal-close"
                    onClick={handleCloseQualificationForm}
                  >
                    <IoClose />
                  </button>
                </div>

                <form
                  className="qualification-form-modal-grid"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="qualification-form-group">
                    <label className="qualification-form-label">
                      Course Name{" "}
                      <span className="qualification-form-required">*</span>
                    </label>
                    <select
                      name="course_name"
                      value={qualificationFormData.course_name}
                      onChange={handleQualificationInputChange}
                      className={`qualification-form-input ${qualificationErrors.course_name ? "qualification-form-error" : ""}`}
                    >
                      <option value="">Select Course</option>
                      {
                        [{

                          id: 1,
                          courseName: "High School",
                          value: "High School",

                        }, {
                          id: 2,
                          courseName: "Intermediate",
                          value: "Intermediate",
                        }, {
                          id: 4,
                          courseName: "UG-Program",
                          value: "UG",
                        }, {
                          id: 4,
                          courseName: "PG - 1st Year",
                          value: "PG-1",
                        }, {
                          id: 3,
                          courseName: "Other",
                          value: "Other",
                        }].map((course) => {

                          const isPreAdd = qualifications.find((cou)=>{

                            if(cou.course_name == course.value) return true

                            return false

                          })
                          return (
 <option key={course.id} style={{
  cursor:`${isPreAdd ? "no-drop" : "pointer"}`
 }} disabled={isPreAdd} value={course.value}>{course.courseName}</option>
                          )
                         
                        })
                      }
                    </select>
                    {qualificationErrors.course_name && (
                      <span className="qualification-form-error-message">
                        {qualificationErrors.course_name}
                      </span>
                    )}
                  </div>

                  <div className="qualification-form-group">
                    <label className="qualification-form-label">
                      Course Detailed Name{" "}
                      <span className="qualification-form-required">*</span>
                    </label>
                    <input
                      type="text"
                      name="course_detailed_name"
                      value={qualificationFormData.course_detailed_name}
                      onChange={handleQualificationInputChange}
                      className={`qualification-form-input ${qualificationErrors.course_detailed_name ? "qualification-form-error" : ""}`}
                      placeholder={
                        qualificationFormData.course_name === "Other"
                          ? "Enter detailed course name"
                          : "Auto-filled from course name"
                      }
                      readOnly={qualificationFormData.course_name !== "Other"}
                      disabled={qualificationFormData.course_name !== "Other"}
                    />
                    {qualificationErrors.course_detailed_name && (
                      <span className="qualification-form-error-message">
                        {qualificationErrors.course_detailed_name}
                      </span>
                    )}
                  </div>

                  <div className="qualification-form-group">
                    <label className="qualification-form-label">
                      Roll Number{" "}
                      <span className="qualification-form-required">*</span>
                    </label>
                    <input
                      type="text"
                      name="roll_no"
                      value={qualificationFormData.roll_no}
                      onChange={handleQualificationInputChange}
                      className={`qualification-form-input ${qualificationErrors.roll_no ? "qualification-form-error" : ""}`}
                      placeholder="e.g., 2021001"
                    />
                    {qualificationErrors.roll_no && (
                      <span className="qualification-form-error-message">
                        {qualificationErrors.roll_no}
                      </span>
                    )}
                  </div>

                  <div className="qualification-form-group">
                    <label className="qualification-form-label">
                      Course Year{" "}
                      <span className="qualification-form-required">*</span>
                    </label>
                    <input
                      type="text"
                      name="course_year"
                      value={qualificationFormData.course_year}
                      onChange={handleQualificationInputChange}
                      className={`qualification-form-input ${qualificationErrors.course_year ? "qualification-form-error" : ""}`}
                      placeholder="e.g., 2024"
                      maxLength="4"
                    />
                    {qualificationErrors.course_year && (
                      <span className="qualification-form-error-message">
                        {qualificationErrors.course_year}
                      </span>
                    )}
                  </div>

                  <div className="qualification-form-group">
                    <label className="qualification-form-label">
                      Board{" "}
                      <span className="qualification-form-required">*</span>
                    </label>
                    <input
                      type="text"
                      name="board"
                      value={qualificationFormData.board}
                      onChange={handleQualificationInputChange}
                      className={`qualification-form-input ${qualificationErrors.board ? "qualification-form-error" : ""}`}
                    />
                    {qualificationErrors.board && (
                      <span className="qualification-form-error-message">
                        {qualificationErrors.board}
                      </span>
                    )}
                  </div>

                  <div className="qualification-form-group">
                    <label className="qualification-form-label">
                      School/College{" "}
                      <span className="qualification-form-required">*</span>
                    </label>
                    <input
                      type="text"
                      name="course_from"
                      value={qualificationFormData.course_from}
                      onChange={handleQualificationInputChange}
                      className={`qualification-form-input ${qualificationErrors.course_from ? "qualification-form-error" : ""}`}
                    />
                    {qualificationErrors.course_from && (
                      <span className="qualification-form-error-message">
                        {qualificationErrors.course_from}
                      </span>
                    )}
                  </div>

                  <div className="qualification-form-group">
                    <label className="qualification-form-label">
                      Total Marks{" "}
                      <span className="qualification-form-required">*</span>
                    </label>
                    <input
                      type="number"
                      name="total_marks"
                      value={qualificationFormData.total_marks}
                      onChange={handleQualificationInputChange}
                      className={`qualification-form-input ${qualificationErrors.total_marks ? "qualification-form-error" : ""}`}
                      placeholder="e.g., 100"
                      step="0.01"
                    />
                    {qualificationErrors.total_marks && (
                      <span className="qualification-form-error-message">
                        {qualificationErrors.total_marks}
                      </span>
                    )}
                  </div>

                  <div className="qualification-form-group">
                    <label className="qualification-form-label">
                      Obtained Marks{" "}
                      <span className="qualification-form-required">*</span>
                    </label>
                    <input
                      type="number"
                      name="obtained_marks"
                      value={qualificationFormData.obtained_marks}
                      onChange={handleQualificationInputChange}
                      className={`qualification-form-input ${qualificationErrors.obtained_marks ? "qualification-form-error" : ""}`}
                      placeholder="e.g., 85"
                      step="0.01"
                    />
                    {qualificationErrors.obtained_marks && (
                      <span className="qualification-form-error-message">
                        {qualificationErrors.obtained_marks}
                      </span>
                    )}
                  </div>

                  <div className="qualification-form-group">
                    <label className="qualification-form-label">
                      Obtained Percentage{" "}
                      <span className="qualification-form-required">*</span>
                    </label>
                    <input
                      type="number"
                      name="obtained_perc"
                      value={qualificationFormData.obtained_perc}
                      onChange={handleQualificationInputChange}
                      className={`qualification-form-input ${qualificationErrors.obtained_perc ? "qualification-form-error" : ""}`}
                      placeholder="e.g., 85.5"
                      step="0.01"
                      min="0"
                      max="100"
                    />
                    {qualificationErrors.obtained_perc && (
                      <span className="qualification-form-error-message">
                        {qualificationErrors.obtained_perc}
                      </span>
                    )}
                  </div>

                  <div className="qualification-form-group qualification-form-group-full">
                    <label className="qualification-form-label">
                      Subjects{" "}
                      <span className="qualification-form-required">*</span>
                    </label>
                    <textarea
                      name="subjects"
                      value={qualificationFormData.subjects}
                      onChange={handleQualificationInputChange}
                      className={`qualification-form-textarea ${qualificationErrors.subjects ? "qualification-form-error" : ""}`}
                      placeholder="Enter subjects separated by commas"
                      rows="3"
                    />
                    {qualificationErrors.subjects && (
                      <span className="qualification-form-error-message">
                        {qualificationErrors.subjects}
                      </span>
                    )}
                  </div>
                </form>
                <div className="qualification-form-modal-footer">
                  <button
                    type="button"
                    className="cancel-button-2"
                    onClick={handleCloseQualificationForm}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="save-button-2"
                    onClick={handleAddQualification}
                  >
                    {isEditingQualification ? "Update" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EducationDetails;
